import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentDocumentsListWireframe from './VeltNotificationsPanelContentDocumentsListWireframe/VeltNotificationsPanelContentDocumentsListWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltNotificationsPanelContentDocumentsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentDocumentsWireframe.List = VeltNotificationsPanelContentDocumentsListWireframe;
export default VeltNotificationsPanelContentDocumentsWireframe;
